import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { OffersSection } from './components/OffersSection';
import { HowItWorks } from './components/HowItWorks';
import { TrustSection } from './components/TrustSection';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="min-h-screen">
      <Navigation />
      <Hero />
      <OffersSection />
      <HowItWorks />
      <TrustSection />
      <Testimonials />
      <FAQ />
      <ContactSection />
      <Footer />
    </div>
  );
}

export default App;
